import "./AddressModal.css";

import "bootstrap/dist/css/bootstrap.min.css";

import React, { useEffect } from "react";

import TextInput from "../TextInput/TextInput";

import DefaultButton from "../DefaultButton/DefaultButton";

import { GlobalContext } from "../../pages/GlobalContext";
import DefaultModal from "../DefaultModal/DefaultModal";
import addressService from "../../services/address-service";
import nutritionistService from "../../services/nutritionist-service";

const AddressModal = ({
  nutritionistId,
  address,
  showModal,
  onClose,
  onSuccess,
  onError,
}) => {
  const [openModal, setOpenModal] = React.useState(showModal);
  const [cep, setCep] = React.useState("");
  const [city, setCity] = React.useState("");
  const [state, setState] = React.useState("");
  const [neighborhood, setNeighborhood] = React.useState("");
  const [street, setStreet] = React.useState("");
  const [number, setNumber] = React.useState("");
  const [complement, setComplement] = React.useState("");
  const [cepInvalid, setCepInvalid] = React.useState(false);

  const { setIsLoading } = React.useContext(GlobalContext);

  const fieldsWereFilled = cep.length === 8 && city.length > 0 && state.length > 0 && neighborhood.length > 0 && street.length > 0 && number.length > 0;

  useEffect(() => {
    if (address) {
      setCep(address.zip_code);
      setCity(address.city);
      setState(address.state);
      setNeighborhood(address.neighborhood);
      setStreet(address.street);
      setNumber(address.number);
      setComplement(address.complement);
    }
  }, [address, showModal]);

  const fetchAddress = async (zipCode) => {
    if (zipCode?.length !== 8) {
      return;
    }

    setIsLoading(true);

    try {
      const address = await addressService.getAddress(zipCode);
      setCity(address?.city || "");
      setState(address?.uf || "");
      setNeighborhood(address?.neighborhood || "");
      setStreet(address?.street || "");
    } catch (ex) {
      console.log("Error fetching address", ex);
      setCepInvalid(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateNutritionistAddress = async () => {
    setIsLoading(true);

    const nutritionistAddress = {
      address: {
        country: 'BRAZIL',
        zip_code: cep,
        city,
        state,
        neighborhood,
        street,
        number,
        complement,
      },
    }

    try {
      const nutritionist = await nutritionistService.updateNutritionist(nutritionistId, nutritionistAddress);
      onSuccess(nutritionist);
      handleCloseModal();
    } catch (ex) {
      onError(ex);
    } finally {
      setIsLoading(false);
    }
  }

  const handleCloseModal = () => {
    setOpenModal(false);
    setCep("");
    setCity("");
    setState("");
    setNeighborhood("");
    setStreet("");
    setNumber("");
    setComplement("");
    onClose();
  }

  const handleChangeZipCode = async (zipCode) => {
    setCep(zipCode);
    setCity("");
    setState("");
    setNeighborhood("");
    setStreet("");
    setNumber("");
    setComplement("");
    setCepInvalid(false);

    if (zipCode?.length === 8) {
      await fetchAddress(zipCode);
    }
  }

  useEffect(() => {
    setOpenModal(showModal);
  }, [showModal]);

  return (
    <DefaultModal
      title="Endereço"
      showModal={openModal}
      onClose={handleCloseModal}
    >
      <div className="address-modal__input">
        <TextInput
          label="CEP"
          type="number"
          maxLength={8}
          minimum={0}
          placeholder="CEP"
          onChangeText={(text) => handleChangeZipCode(text)}
          invalid={cepInvalid}
          invalidMessage="O CEP informado é inválido"
          value={cep}
        />
      </div>
      <div className="address-modal__city-state">
        <TextInput
          label="Cidade"
          placeholder="Cidade"
          style="address-modal__city"
          onChangeText={(text) => setCity(text)}
          value={city}
          disabled
        />
        <TextInput
          label="Estado"
          placeholder="Estado"
          style="address-modal__state"
          onChangeText={(text) => setState(text)}
          value={state}
          disabled
        />
      </div>
      <div className="address-modal__input">
        <TextInput
          label="Bairro"
          placeholder="Bairro"
          onChangeText={(text) => setNeighborhood(text)}
          value={neighborhood}
          disabled
        />
      </div>
      <div className="address-modal__input">
        <TextInput
          label="Rua"
          placeholder="Rua"
          onChangeText={(text) => setStreet(text)}
          value={street}
          disabled
        />
      </div>
      <div className="address-modal__input">
        <TextInput
          type="number"
          label="Número"
          placeholder="Número"
          onChangeText={(text) => setNumber(text)}
          value={number}
          disabled={!street.length || !neighborhood.length === 0}
        />
      </div>
      <div className="address-modal__input">
        <TextInput
          label="Complemento"
          placeholder="Complemento"
          onChangeText={(text) => setComplement(text)}
          value={complement}
          disabled={!street.length || !neighborhood.length === 0}
        />
      </div>
      <div className="address-modal__actions">
        <DefaultButton
          className="address-modal__cancel-button"
          onClick={() => handleUpdateNutritionistAddress()}
          disabled={!fieldsWereFilled}
          title="Salvar"
        />
      </div>
    </DefaultModal>
  );
};

AddressModal.propTypes = {
};

export default AddressModal;
